import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

import { DocContentComponent } from './doc-content/doc-content.component';
import { DocCodeBlockComponent } from './doc-code-block/doc-code-block.component';
import { DocTabsComponent } from './doc-tabs/doc-tabs.component';
import { DocCalloutComponent } from './doc-callout/doc-callout.component';
import { DocTabPanelDirective } from './doc-tab-panel.directive';

@NgModule({
  declarations: [
    DocContentComponent,
    DocCodeBlockComponent,
    DocTabsComponent,
    DocCalloutComponent,
    DocTabPanelDirective,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ClipboardModule,
    MatIconModule,
    MatTabsModule,
  ],
  exports: [
    DocContentComponent,
    DocCodeBlockComponent,
    DocTabsComponent,
    DocCalloutComponent,
    DocTabPanelDirective,
    CommonModule,
  ],
})
export class SharedDocModule {}
